"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getMembers = void 0;
/**
 * Get a contact from the storage
 *
 * @alpha
 * @typeParam T The type of the repository that should be derived from {@link IMembersRepository}
 * @param repository The repository instance to handle contacts. See {@link membersRepository}
 *
 * @returns A contact if found in storage otherwise null
 *
 * @example
 * ```ts
 * getMembers(contactRepository); // null or IContact
 * ```
 */
function getMembers(repository) {
    return repository.getMembers() || [];
}
exports.getMembers = getMembers;
//# sourceMappingURL=get-members.js.map